
import { Vue, Component, Prop } from 'vue-property-decorator';
import SidePanel from '@/features/common/components/SidePanel.vue';
import { getPrice } from '@/features/common/helpers';
import { LandedCostResponse } from '@/features/shipment/types';

@Component({
  components: { SidePanel },
})
export default class DutiesTaxesSidePanel extends Vue {
  @Prop({ required: true }) landedCost!: LandedCostResponse;

  @Prop({ default: false }) showPanel!: boolean;

  private formatPrice = getPrice;

  private onPanelInput(val: boolean): void {
    if (!val) this.$emit('close');
  }
}
